import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import "./codeauditstyle.css";
import pdficon from "./../Asset/PDF.png";
import csvicon from "./../Asset/CSV.png";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Breadcrumbs, Typography } from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';
import { useNavigate } from "react-router-dom";
import { Commonfun } from './../Commonfun';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import CommonAlert from "../../../Commonalert/commonalert";
import ErrorCountimg from "../Asset/esocardicon/SourceCodeAnalysis/ErrorCount.svg"
import FatalErrorCountimg from "../Asset/esocardicon/SourceCodeAnalysis/FatalErrorCount.svg"
import WarningCountimg from "../Asset/esocardicon/SourceCodeAnalysis/WarningCount.svg"
import { AppContext } from "../../../Context/Context";
import Commoncard from "../Commoncard";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import UserActivityTracker from "../../../hooks/userActivityTracker";

export default function CodeauditDetail({ reportStatus = false, instantReport = "" }) {
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [jobDate, setjobDate] = useState("");
  const [jobidData, setjobidData] = useState("");
  const [domainsecid, setDomainsecid] = useState("");
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [aiMap, setAiMap] = useState({});
  let querystring = useParams();
  let code_audit_id = querystring.id;
  let job_audit_id = querystring.jobid;

  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value
  const navigate = useNavigate();
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);

  useEffect(() => {
    if (reportStatus) {
      applyInstantReport();
    } else {
      callUserdataApi();
    }
  }, [instantReport]);
  const apihandleClose = () => {
    setapiOpen(false);
  };
  const callUserdataApi = async (jobid = "") => {
    setLoading(true);

    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}technical/v2/sourcecode_detail_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${job_audit_id}&id=${code_audit_id}`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      setLoading(false);
      if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
        return false;
      }
      else if (error?.code == "ERR_NETWORK") {
        navigate('/errorpages')
      }
    });
    const dataval = datavalue?.data;
    if (datavalue?.data?.job_date)
      setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"))
    else
      setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"))
    setCardData(dataval);
  };

  const applyInstantReport = () => {

    if (instantReport) {
      const dataval = instantReport;
      if (instantReport?.date)
        setjobDate(moment(instantReport?.date).format("MMMM DD,YYYY HH:mm"))
      else
        setjobDate(moment(instantReport?.date).format("MMMM DD,YYYY"))
      setCardData(dataval);
    };
  }

  const pdfdown = async () => {

    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/v2/sourcecode_detail_table/?user_domain_id=${esodata.domaindata.value.header_selected}&id=${code_audit_id}&job_id=${job_audit_id}&formats=pdf&domain_section_id=${domainsecid}&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        var filedata = await Commonfun("SourceCodeDetails", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        toast.error("No Data", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.error('Failed to fetch PDF:', response.status, response.statusText);
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);
  }
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/v2/sourcecode_detail_table/?user_domain_id=${esodata.domaindata.value.header_selected}&id=${code_audit_id}&job_id=${job_audit_id}&formats=csv&domain_section_id=${domainsecid}&timezone=${timezoneval()}`, {

        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("SourceCodeDetails", "csv", ApiToken, esodata.domaindata.value.header_selected);

        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        toast.error("No Data", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.error('Failed to fetch PDF:', response.status, response.statusText);
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);
  }

  const fetchAiSuggestion = async (issueId) => {
    setAiMap((prev) => ({
      ...prev,
      [issueId]: { loading: true, data: "" },
    }));

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}technical/sourcecode_ai/`,
        {
          id: code_audit_id,   
          job_id: job_audit_id,
          sid: issueId,      
        },
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );

      setAiMap((prev) => ({
        ...prev,
        [issueId]: {
          loading: false,
          data: response.data.suggestion,
        },
      }));

    } catch (error) {
      console.error("AI API Error:", error);

      setAiMap((prev) => ({
        ...prev,
        [issueId]: {
          loading: false,
          data: "Failed to fetch suggestion.",
        },
      }));
    }
  };


  // const cardDatas = [
  //   { title: "Fatal Error Count", value: cardData?.fatal_error, iconSrc: FatalErrorCountimg, altText: "Fatal Error Count" },
  //   { title: "Error Count", value: cardData?.error, iconSrc: ErrorCountimg, altText: "Error Count" },
  //   { title: "Warning Count", value: cardData?.warning, iconSrc: WarningCountimg, altText: "Warning Count" }
  // ];

  const cardDatas = [
    {

      value: cardData?.fatal_error || 0,
      title: "Fatal Error Count",
      badge: "SEO",
      iconSrc: FatalErrorCountimg,
      iconColor: 1,
      bgColor: 1,

    },
    {

      value: cardData?.error || 0,
      title: "Error Count",
      badge: "TRAFFIC",
      iconSrc: ErrorCountimg,
      iconColor: 2,
      bgColor: 2,

    },
    {

      value: cardData?.warning || 0,
      title: "Warning Count",
      badge: "TRAFFIC",
      iconSrc: WarningCountimg,
      iconColor: 3,
      bgColor: 3,

    },

  ];


  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {!reportStatus &&
        <>
          <Container maxWidth={false} className="dashboard-container">
            <Box className="dashboard-box">
              <Grid container className="dashboard-grid">
                <Grid item xs={12} md={4}>
                  <div>
                    <h1 className="dashboard_header">
                      Source Code Detailed Report
                    </h1>
                  </div>
                </Grid>
                <Grid item xs={12} md={8}>
                  <div className="top_breadcrumb_menu">
                    <div className="exportpdf_outer">
                      <div className="breadcrumb-wrapper">
                        <CommonBreadCrumb breadcrumbValue={[
                          { title: 'Technical' },
                          { title: 'Source Code Analysis', activeColor: true, link: '/source-code' },
                          { title: 'Source Code Detailed Report', activeColor: true }
                        ]} />
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </Container>

          <Container maxWidth={false} className="dashboard-container">
            <Box className="dashboard-box-time">
              <Grid container className="dashboard-grid">
                <Grid item xs={12} md={6}>
                  <div className="time_zone">
                    <span>
                      <a target="_blank" href={cardData?.url}>
                        <span style={{ display: 'inline-block' }} className="spanlink">
                          {cardData?.url}
                        </span>
                      </a>
                    </span><br></br>
                    <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                    <span className="timezone-val">{timezoneval()}</span>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div style={{ display: "block", textAlign: "end" }}>
                    <div className="dashboard_download" style={{ justifyContent: "end", display: "inline-flex", cursor: "pointer" }} onClick={isDownloading ? null : pdfdown}>
                      Download PDF
                      <svg
                        className="filter"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="7 10 12 15 17 10" />
                        <line x1="12" y1="15" x2="12" y2="3" />
                      </svg>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </>
      }

      <Container maxWidth={false} className="dashboard-card-container">
        <Box >
          <Grid container className="dashboard-box-card">
            <Grid container spacing={3} justifyContent="center">
              {cardDatas.map((item, index) => (
                <Grid item xs={12} sm={6} md={3} key={item.id}>
                  <Commoncard
                    item={item}
                    nonclikable={true}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div>
                {/* <div className="cnt_hdr_content">
                  <div className="box_wrap">
                    <div>
                      <h1> </h1>
                      <p></p>
                    </div>
                    <div className="common-card-container" style={{ justifyContent: "center" }}>
                      {cardDatas.map(({ title, value, iconSrc, altText }) => (
                        <Commoncard key={title} title={title} value={value} iconSrc={iconSrc} altText={altText} nonclikable={true} />
                      ))}
                    </div>

                  </div>
                </div> */}

                <div className="cnt_hdr_content_table">
                  <div className="box_wrap">
                    <div className="issues-container">
                      {cardData?.data?.length > 0 ? (
                        cardData.data.map((item) => (
                          <div key={item.id} className="issue-card">

                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                              <div>
                                <p><strong>{item.type}: </strong>{item.issue_text} </p>

                                {item.line && (
                                  <p><strong>Location:</strong> {item.line}</p>
                                )}
                              </div>

                              <div>
                                {code_audit_id && job_audit_id && (
                                  <button
                                    onClick={() => fetchAiSuggestion(item.id)}
                                    className="ai-btn"
                                  >
                                    AI Suggestion
                                  </button>
                                  )}
                              </div>
                            </div>

                            {item.snippet && (
                              <pre className="snippet">{item.snippet}</pre>
                            )}

                            {aiMap[item.id] && (
                              <div className="ai-response">
                                {aiMap[item.id].loading ? (
                                  <p>Loading...</p>
                                ) : (
                                  <pre>{aiMap[item.id].data}</pre>
                                )}
                              </div>
                            )}

                          </div>
                        ))
                      ) : (
                        <p>No issues found</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {!reportStatus &&
        <Container maxWidth={false} className="footer-container">
          <Box className="footer-box">
            <Grid container className="footer-grid">
              <Grid item xs={12} md={6}>
                <div className="footer-left">
                  <p className="footer-text">
                    All Rights Reserved Copyright © 2026 |
                    <a href="https://www.egrovesys.com/" target="blank">
                      <span className="footer-brand"> Elite site Optimizer</span>
                    </a>
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="footer-right">
                  <p>{/* Add content if needed */}</p>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
      }


      {/* <div className="cnt_audit_outer_wrap src-detail">
        <div className="top_breadcrumb_menu">
          <CommonBreadCrumb breadcrumbValue={[
            { title: 'Technical' },
            { title: 'Source Code Analysis', activeColor: true, link: '/source-code' },
            { title: 'Source Code Detailed Report', activeColor: true }
          ]} />
          <div className="exportpdf_outer">
            <>
              <button className="exportpdf" alt="pdf icon" onClick={isDownloading ? null : pdfdown} title="PDF Download" ><GetAppIcon />PDF</button>
            </>
          </div>
        </div>
        <div className="cnt_hdr_top_wraps">
          <div className="cnt_hdr_top_lft_wrap">
            <div style={{ display: "flex" }}>
              <h2 className="heading_font" style={{ letterSpacing: "0.8px", fontWeight: 900, color: "#ff601f" }}>Source Code Detailed Report</h2>
            </div>
            <a target="_blank" href={cardData?.url} style={{ display: 'flex', flexDirection: 'column' }}>
              <span className="spanlink">
                &nbsp; {cardData?.url}
              </span>
            </a>
            <p style={{ fontSize: "14px", letterSpacing: "0.8px", color: "#ff601fc2" }}>as of {timezonechange(jobDate)}  <span style={{ fontWeight: 700 }}>  {timezoneval()} </span></p>
          </div>
        </div>
        <div className="cnt_hdr_content">
          <div className="box_wrap">
            <div>
              <h1> </h1>
              <p></p>
            </div>
            <div className="common-card-container" style={{ justifyContent: "center" }}>
              {cardDatas.map(({ title, value, iconSrc, altText }) => (
                <Commoncard key={title} title={title} value={value} iconSrc={iconSrc} altText={altText} nonclikable={true} />
              ))}
            </div>

          </div>
        </div>

        <div className="cnt_hdr_content_table">
          <div className="box_wrap">
            <div
              className="post__content"
              dangerouslySetInnerHTML={{ __html: cardData?.html_data }}
            ></div>
          </div>
        </div>
      </div> */}
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }
      <UserActivityTracker pagename="Technical - Source Code Analysis - Source Code Detailed Report" />
    </div>
  );
}
